import { InputAdornment, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import { useOutlet, useSearchParams } from "react-router-dom";
import { getScreeningTree } from "../../server/server";
import { GroupNode, GroupsTree } from "./components/GroupComponent";
import DefaultJur from "./screens/DefaultJur";

function Jurisdiction() {
  const [term, setTerm] = useState("");
  const [groups, setGroups] = useState<GroupNode[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const outlet = useOutlet();
  const [searchParams, setSearchParams] = useSearchParams();

  const showAll = searchParams.get("allJurisdictions") === "1";
  const selectedGroup = searchParams.get("group");
  const selectedNo = searchParams.get("no");
  const hasSelectedChapter = Boolean(selectedGroup && selectedNo);

  const handleTermDelete = () => {
    if (term) {
      setTerm("");
    }
  };

  useEffect(() => {
    loadGroups(term);
  }, [term]);

  const loadGroups = async (term: string) => {
    setIsLoading(true);
    const resp = await getScreeningTree(term);

    if (resp?.status === 200) {
      setGroups(resp?.data);
    } else {
      setGroups([]);
    }
    setIsLoading(false);
  };

  const handleShowAll = () => {
    const next = new URLSearchParams(searchParams);
    next.delete("group");
    next.delete("no");
    next.set("allJurisdictions", "1");
    setSearchParams(next);
  };

  return (
    <div className="w-full h-full flex flex-row justify-start">
      <div className="h-full bg-[#1e3f940a] w-[630px] my-5 first:mt-0">
        <div className="w-full flex items-center justify-center mt-6 mb-4">
          <TextField
            label='"Претрага "Screening"-a"'
            id="outlined-size-small"
            type="screening"
            name="screening"
            sx={{ width: 380 }}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  onClick={handleTermDelete}
                  className="cursor-pointer min-h-[35px]"
                >
                  {term ? <FaTimes /> : <FaSearch />}
                </InputAdornment>
              ),
            }}
            size="small"
            value={term}
            onChange={(e) => setTerm(e.target.value)}
          />
        </div>

        <div className="overflow-auto gray-small-scroll h-full">
          {!isLoading && groups?.length === 0 ? (
            <div className="px-6 py-4 text-center text-sm text-[#6b7280]">
              Не постоје Screening поглавља са задатим критеријумом
            </div>
          ) : (
            <GroupsTree groups={groups} handleShowAll={handleShowAll} />
          )}
        </div>
      </div>

      <div
        className="w-full h-full overflow-y-scroll gray-small-scroll help-page"
        style={{ scrollSnapType: "y mandatory" }}
      >
        {outlet ? (
          outlet
        ) : hasSelectedChapter || showAll ? (
          <DefaultJur />
        ) : (
          <div className="h-[calc(100%-60px)] flex items-center justify-center text-sm text-[#6b7280] px-6 text-center">
            Одаберите поглавље са леве стране да бисте приказали надлежности.
          </div>
        )}
      </div>
    </div>
  );
}

export default Jurisdiction;
